import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlassian/wac-ufo-segment";

import ContentBlock from "@/components/wpl/content-block/src";
import { useLocalizedHref } from "@/libraries/web-framework";

const heroContainerStyles = css({
    "backgroundColor": "#1868DB",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "100%",
    "maxWidth": "1301px",
    "margin": "0 auto",
    "gap": "32px",
    "position": "relative",
    "padding": "58px 0 73px 0",
    "border": "0",
    "clipPath":
        "polygon(0.000px 0.445px, 1301.000px 27.008px, 1301.000px 100%, 0.000px calc(100% - 7.512px), 0.000px 0.445px)",
    [media.below.md]: {
        padding: "64px 60px 64px 60px"
    },
    [media.below.sm]: {
        flexDirection: "column",
        padding: "64px 32px 41px 32px"
    },

    ".contentBlock-linkFlex": {
        margin: "0px"
    },

    ".textContainerStyles": {
        "width": "100%",
        "maxWidth": "368px",
        [media.only.sm]: {
            flex: 1
        },
        ".text-section": {
            gap: "8px",
            h4: {
                color: "#FFF",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "30px" /* 125% */,
                letterSpacing: "0.3px",
                width: "100%",
                maxWidth: "368px",
                margin: "0",

                [media.below.md]: {
                    fontSize: "22px",
                    lineHeight: "28px" /* 127.273% */
                },
                [media.below.sm]: {
                    fontSize: "20px",
                    lineHeight: "26px" /* 130% */
                }
            },

            p: {
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                margin: "0",
                fontSize: "1rem",
                width: "100%",
                maxWidth: "368px",
                color: "#FFF",
                marginBlockEnd: "8px"
            },

            a: {
                margin: "0 !important"
            },

            [media.below.sm]: {
                alignItems: "center",
                textAlign: "center"
            }
        }
    }
});

const imageContainerStyles = css({
    position: "relative"
});

const imageStyles = css({
    width: "311px",
    height: "207.897px",
    flex: "none",
    [media.only.sm]: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        width: "unset",
        height: "unset"
    },
    [media.above.sm]: {
        width: "368px",
        height: "246px"
    }
});

export const CommunitySectionImage = () => {
    const intl = useIntl();

    const imageAlt = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.ImageAlt",
        defaultMessage: "Globe"
    });

    return (
        <div css={imageContainerStyles}>
            <img
                alt={imageAlt}
                css={imageStyles}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-community-globe.webp"
                loading="lazy"
            />
        </div>
    );
};

export const CommunitySection = () => {
    const intl = useIntl();

    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Header",
        defaultMessage: "Connect with our 4.5M+ community members"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Description",
        defaultMessage:
            "Ask questions, give product feedback, and connect with our team and other users to learn best practices. From events and forums, to curated learning paths, you’re never alone when you are an Atlassian customer."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Cta",
        defaultMessage: "Check out community"
    });

    return (
        <UFOSegment name="hero">
            <div
                css={css({
                    backgroundImage:
                        "linear-gradient(1deg, transparent, transparent 45%, #F8F8F8 45.1%, #F8F8F8)"
                })}
            >
                <div css={heroContainerStyles}>
                    <ContentBlock
                        headerText={headerText}
                        headerType="h4"
                        bodyText={descriptionText}
                        className="textContainerStyles"
                        ctaProps={{
                            primaryLinkProps: {
                                text: buttonText,
                                href: useLocalizedHref("/community"),
                                className: "jiraLinkStyling",
                                dataEventProps: {
                                    "data-product-key": "jiraSoftware",
                                    "data-event": "clicked",
                                    "data-event-container":
                                        "communityCtaSection",
                                    "data-event-component": "link"
                                },
                                customLinkColor: "#FFF"
                            }
                        }}
                    />
                    <CommunitySectionImage />
                </div>
            </div>
        </UFOSegment>
    );
};
